/**
 * The root saga function. This function is used to register all sagas watching the store
 */
import notificationsSaga from "./notifications/sagas";
import { all } from "redux-saga/effects";
import accountSaga from "./account/sagas";
import bottleAliasesSaga from "./bottleservice/aliases/sagas";
import collaboratorSaga from "./collaborators/sagas";
import communityAnnouncementsSaga from "./communityAnnouncements/sagas";
import contentCategoriesSaga from "./contentCategories/sagas";
import contractsSaga from "./contracts/sagas";
import contractTemplatesSaga from "./contractTemplates/sagas";
import creatorSaga from "./creators/sagas";
import dashboardPanelsSaga from "./dashboardPanels/sagas";
import dictionarySaga from "./dictionarySagas";
import errorsSaga from "./errorsSagas";
import eventRegistrationsSaga from "./eventRegistrations/sagas";
import eventsSaga from "./events/sagas";
import faqListsSaga from "./faqLists/sagas";
import faqsSaga from "./faqs/sagas";
import holderSaga from "./holders/sagas";
import mintTierSaga from "./mintTiers/sagas";
import mintVoucherSaga from "./mintVouchers/sagas";
import navigationItemSaga from "./navigationItems/sagas";
import pagesSaga from "./pages/sagas";
import partnerDealsSaga from "./partnerDeals/sagas";
import projectSaga from "./projects/sagas";
import projectBillingInfoSaga from "./projectBillingInfos/sagas";
import projectDashboardSaga from "./projectDashboards/sagas";
import projectDesignSaga from "./projectDesigns/sagas";
import projectOrdersSaga from "./projectOrders/sagas";
import pushLinksSaga from "./pushLinks/sagas";
import raffleRegistrationsSaga from "./raffleRegistrations/sagas";
import rafflesSaga from "./raffles/sagas";
import roadmapSaga from "./roadmaps/sagas";
import routerHistorySaga from "./routerHistory/sagas";
import serviceWorkerSaga from "./servWork/sagas";
import shopProductSaga from "./shopProducts/sagas";
import shopProductsBidSaga from "./shopProductsBids/sagas";
import shopProductOrderSaga from "./shopProductOrders/sagas";
import siwesSaga from "./siwes/sagas";
import tagsSaga from "./tags/sagas";
import tmpFilesSaga from "./tmpFiles/sagas";
import tokenHistoryEventsSaga from "./tokenHistoryEvents/sagas";
import tokensSaga from "./tokens/sagas";
import traitsSaga from "./traits/sagas";
import traitTypesSaga from "./traitTypes/sagas";
import tribesSaga from "./tribes/sagas";
import unlockableContentsSaga from "./unlockableContents/sagas";
import unlockBoundariesSaga from "./unlockBoundaries/sagas";
import unlockInputsSaga from "./unlockInputs/sagas";
import utilityContractsSaga from "./utilityContracts/sagas";
import votingOptionSaga from "./votingOptions/sagas";
import votingsSaga from "./votings/sagas";
import walletProfileInputSaga from "./walletProfileInputs/sagas";
import walletSaga from "./wallets/sagas";
import whitelistWalletsSaga from "./whitelistWallets/sagas";
import analyticsSaga from "./analytics/sagas";

// DON'T DELETE THE FOLLOWING COMMENT: NEEDED FOR UPDATING THIS FILE WITH THE SCAFFOLD SCRIPT
// new scaffolded imports

/** exports the rootSaga for the store */
export default function* rootSaga() {
  yield all([
    accountSaga(),
    bottleAliasesSaga(),
    collaboratorSaga(),
    communityAnnouncementsSaga(),
    contentCategoriesSaga(),
    contractsSaga(),
    contractTemplatesSaga(),
    creatorSaga(),
    dashboardPanelsSaga(),
    dictionarySaga(),
    errorsSaga(),
    eventRegistrationsSaga(),
    eventsSaga(),
    faqListsSaga(),
    faqsSaga(),
    holderSaga(),
    mintTierSaga(),
    mintVoucherSaga(),
    navigationItemSaga(),
    notificationsSaga(),
    pagesSaga(),
    partnerDealsSaga(),
    projectSaga(),
    projectBillingInfoSaga(),
    projectDashboardSaga(),
    projectDesignSaga(),
    projectOrdersSaga(),
    pushLinksSaga(),
    raffleRegistrationsSaga(),
    rafflesSaga(),
    roadmapSaga(),
    routerHistorySaga(),
    serviceWorkerSaga(),
    shopProductSaga(),
    shopProductsBidSaga(),
    shopProductOrderSaga(),
    siwesSaga(),
    tagsSaga(),
    tmpFilesSaga(),
    tokenHistoryEventsSaga(),
    tokensSaga(),
    traitsSaga(),
    traitTypesSaga(),
    tribesSaga(),
    unlockableContentsSaga(),
    unlockBoundariesSaga(),
    unlockInputsSaga(),
    utilityContractsSaga(),
    votingOptionSaga(),
    votingsSaga(),
    walletProfileInputSaga(),
    walletSaga(),
    whitelistWalletsSaga(),
    analyticsSaga(),
    // DON'T DELETE THE FOLLOWING COMMENT: NEEDED FOR UPDATING THIS FILE WITH THE SCAFFOLD SCRIPT
    // new scaffolded sagas
  ]);
}
